import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, HStack, Text, VStack } from "native-base";
import { useEffect, useState } from "react";
import { InsulinType } from "@madmedical/medical";
import { useFormContext } from "@madmedical/form";
import { useTranslation } from "@madmedical/i18n";
import SubmitButton from "../form/SubmitButton";
import TimeInput from "../form/TimeInput";
import Button from "../atoms/Button";
import ModalContent from "../molecules/ModalContent";
import FormSelect from "../form/FormSelect";
import FormTextAreaControl from "../form/FormTextAreaControl";
import { formatType } from "../util/insulinFormatters";
import MultiCheckboxSelect from "../form/MultiCheckboxSelect";
import useResponsive from "../util/useResponsive";
const InsulinReminderModalForm = ({ onClose, onSubmitPress, isSuccess, isEdit = false, }) => {
    const [isValid, setIsValid] = useState(false);
    const { isSmallScreen } = useResponsive();
    useEffect(() => {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess, onClose]);
    const insulinTypes = [
        { value: InsulinType.Rapid, label: formatType(InsulinType.Rapid) },
        { value: InsulinType.Basal, label: formatType(InsulinType.Basal) },
        { value: InsulinType.Other, label: formatType(InsulinType.Other) },
    ];
    const weekDays = [
        { value: 1, label: "Hétfő" },
        { value: 2, label: "Kedd" },
        { value: 3, label: "Szerda" },
        { value: 4, label: "Csütörtök" },
        { value: 5, label: "Péntek" },
        { value: 6, label: "Szombat" },
        { value: 0, label: "Vasárnap" },
    ];
    const { getValues, setValue, watch } = useFormContext();
    const chosenInsulinType = watch("type");
    const chosenDaysOfWeek = watch("daysOfWeek");
    useEffect(() => {
        if (chosenInsulinType && chosenDaysOfWeek.length > 0) {
            setIsValid(true);
        }
        else {
            setIsValid(false);
        }
    }, [chosenInsulinType, chosenDaysOfWeek]);
    const [firstTime, setFirstTime] = useState(undefined);
    useEffect(() => {
        if (isEdit) {
            const { insulinType, daysOfWeek, firstOccurrence } = getValues();
            setValue("type", insulinType);
            setValue("daysOfWeek", daysOfWeek);
            setFirstTime(firstOccurrence);
        }
    }, [isEdit, setValue, getValues]);
    const { t } = useTranslation();
    return (_jsx(ModalContent, Object.assign({ header: `${t("injectionReminder")} ${isEdit ? t("editing") : t("setup")}`, footer: _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onPress: onClose, variant: "outlined" }, { children: t("cancel") })), _jsx(SubmitButton, { onPress: onSubmitPress, label: t("save"), isDisabled: !isValid })] }) }, { children: _jsxs(VStack, Object.assign({ overflowY: "clip" }, { children: [_jsxs(HStack, Object.assign({ space: 2, direction: isSmallScreen ? "column" : "row" }, { children: [_jsx(TimeInput, { name: "firstOccurrence", isRequired: true, label: t("appointment"), previousTime: isEdit ? firstTime : undefined }), _jsx(MultiCheckboxSelect, { list: weekDays.map((day) => ({
                                key: day.value.toString(),
                                text: day.label,
                            })), name: "daysOfWeek", label: "Ism\u00E9tl\u00E9s", width: "100%", allSelectedLabel: "Minden nap" })] })), _jsx(HStack, Object.assign({ mt: 2 }, { children: _jsx(FormSelect, { choices: insulinTypes.map((type) => ({
                            value: type.value,
                            label: type.label,
                        })), name: "type", label: "Inzulin t\u00EDpusa", labelProps: { _text: { color: "gray.800" } } }) })), _jsx(Box, Object.assign({ mt: 2 }, { children: _jsx(FormTextAreaControl, { label: t("comment"), name: "comment", labelProps: {
                            _text: { color: "gray.800" },
                        }, maxLength: 100, textareaHeight: 75 }) })), _jsx(Text, Object.assign({ mt: 2, fontSize: "sm", color: "gray.500" }, { children: "Maximum 100 karakter." }))] })) })));
};
export default InsulinReminderModalForm;
